import { createFileRoute } from '@tanstack/react-router'
import { DataLabelingPage } from 'pages/evaluations/metadata/labeling/DataLabelingPage'

import { dataLabelingSearchSchema } from './-searchParams'

function RouteComponent() {
  const search = Route.useSearch()
  return <DataLabelingPage search={search} />
}

export const Route = createFileRoute('/evaluations/metadata/labeling/')({
  component: RouteComponent,
  validateSearch: dataLabelingSearchSchema,
  staticData: {
    title: 'Metadata Labeling',
    layout: {
      enableScrolling: false,
      enforceMaxWidth: false,
      showSearchBar: false,
    },
  },
})
